import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  notifications: [],
};

export const createNotification = createAsyncThunk(
  "createNotification/notification",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("send-notification", data);
      enqueueSnackbar("Notification is added successfully");
      // navigate(PATH_DASHBOARD.notifications.list);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchNotifications = createAsyncThunk(
  "fetchNotifications/notification",
  async ({ enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get("send-notification");
      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  extraReducers: (builder) => {
    // TODO: create product
    builder.addCase(createNotification.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createNotification.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(createNotification.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch product
    builder.addCase(fetchNotifications.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchNotifications.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.notifications = action.payload;
    });

    builder.addCase(fetchNotifications.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // ==========================
  },
});

export default notificationSlice.reducer;
